import { useContext, useState } from "react";
import { AuthContext } from "../../context/auth-context";
import Papa from "papaparse";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import TollCard from "./TollCard";
import { uploadTolls } from "../../api/add";

export default function AddTolls() {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [ignored, setIgnored] = useState([]);

  const submitHandler = (e) => {
    setLoading(true);
    e.preventDefault();

    // Read file and set data
    const file = e.target.file.files[0];
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, { header: true });
      const parsedData = csv?.data;
      uploadTollsHandler(parsedData);
    };
    reader.readAsText(file);
    setLoading(false);
  };

  const uploadTollsHandler = async (data) => {
    try {
      setLoading(true);
      const ignored = await uploadTolls(user, data);
      setIgnored(ignored);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="w-full h-screen p-8 overflow-scroll rounded-xl bg-stone-900">
        <LoadingSpinnerWrapper />
      </div>
    );

  return (
    <div className="container">
      <div className="grid gap-8">
        <div className="grid gap-2">
          <p className="hidden text-lg font-semibold text-white md:block">
            Add Tolls
          </p>
          <hr className="hr" />
          <p className="text-sm text-stone-400">
            Download the csv file of latest tolls from Dealerware and upload
            them here. Duplicate entries are automatically ignored.
          </p>
        </div>

        <form onSubmit={submitHandler} className="grid gap-6">
          <div className="grid gap-4">
            <label className="form-label">Upload CSV:</label>
            <input type="file" name="file" className="form-input" required />
          </div>
          <button type="submit" className="btn-primary md:w-32">
            Submit
          </button>
        </form>

        {ignored.length > 0 && (
          <div className="grid gap-4">
            <p>Tolls Ignored: {ignored.length}</p>
            <div className="grid gap-4 h-[320px] overflow-scroll">
              {ignored.map((toll, index) => (
                <TollCard toll={toll} key={index} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
